import $ from 'jquery';
import InputValidationManagerClass from '../common/InputValidationManagerClass';
import ModalBaseClass from '../../libs/modal/ModalBaseClass';
import Util from '../../libs/util/Util';
import ReceiptModalClass from "./ReceiptModalClass";

/**
 * 領収書発行モーダル
 * @example
 * data-id:申込番号
 * data-of:但し書き
 * data-price:金額
 * にそれぞれ挿入されます
 */
export default class ReciptSelectModalClass extends ModalBaseClass {
  constructor() {
    super('#modal_receipt_select');
    this.name = 'ReciptSelectModalClass';
    this.data_id = '';
    this.easing = 'swing';
    this.onClickOpenListener = this.onClickOpen.bind(this);
  }

  onCreate() {
    super.onCreate();
    $(".js-modal_receipt_select").on("click", this.onClickOpenListener);
    const msgs = [
      "一括発行を一度でも発行してしまうと分割発行ができなくなります。",
      "分割発行を一度でも発行してしまうと一括発行ができなくなります。"
    ];


    $('input[name="reciept_type"]').on('click', (event)=> {
      const visibleElements = $('.receipt-select').filter(function () {
        return $(this).css('display') !== 'none';
      });

      let selectedValue = $(event.target).val();

      if(visibleElements.length > 1){
        let confirmed = confirm(selectedValue == "0" ? msgs[0] : msgs[1]);
        if(confirmed){
          //手動でモーダルを閉じる
          this.onClose();
          //領収書モダールを呼び出す
          if(selectedValue == "0"){
            $('#' + event.target.dataset.tar)[0].click();
            $('#' + event.target.dataset.tar).trigger('click');
          }else{
            $('#' + event.target.dataset.divisionForm).trigger('submit');
          }
        }
      }else {
        //手動でモーダルを閉じる
        this.onClose();
        //領収書モダールを呼び出す
        if(selectedValue == "0"){
          $('#' + event.target.dataset.tar)[0].click();
          $('#' + event.target.dataset.tar).trigger('click');
        }else{
          $('#' + event.target.dataset.divisionForm).trigger('submit');
        }
      }


    });
  }

  onClickOpen(e) {
    e.preventDefault();
    this.onOpen();
  }
  onOpen(e) {
    this.scrollTop = Util.getScrollY();
    this.isOpen = true;
    this.isOpenBefore = true;
    this.target.css({ display: 'block', opacity: 0 });
    Util.isSpModalOpen = true;

    const time = 0.3;
    const ease = Power2.easeOut;
    TweenMax.killTweensOf(this.target);

    TweenMax.to(this.target, time, {
      opacity: 1,
      ease: ease,
      onComplete: () => {
        if (this.isOpenBefore) {
          this.onOpenAfter();
          this.jq.trigger(this.EVENT_OPEN);
          $(window).trigger('resize');
        }
        this.target.css({ transform: '' });
      },
    });

    let p = Util.getWindowScrollWidth();
    $('html').css({ overflow: 'hidden' });
    $('body').css({ overflow: 'hidden', 'padding-right': p });
  }

  onClose() {
    $('html').removeClass(this.CL_MODAL_OPEN);
    if (Util.isBreakpoint) { $('html,body').css({ overflow: 'visible' }); }
    clearTimeout(this.timerId);
    this.isOpenBefore = false;

    const time = 0.3;
    const ease = Power2.easeOut;
    TweenMax.killTweensOf(this.target);

    TweenMax.to(this.target, time, {
      opacity: 0,
      ease: ease,
      onComplete: () => {
        this.target.css({ display: 'none' });
        this.isOpen = false;
        $('html').css({ overflow: '' });
        $('body').css({ overflow: '', 'padding-right': '' });
        Util.isSpModalOpen = false;
        this.jq.trigger(this.EVENT_CLOSE);
      },
    });
    document.body.style.position = "";
  }

}
